import React from 'react';
import styled from 'styled-components';
import moment from 'utils/moment';
import type { IBlockHourHistoryItem } from 'services/types/blockHours';

type HistoryCardProps = {
  item: IBlockHourHistoryItem;
  active?: boolean;
  onClick?: () => void;
};

const HistoryCard: React.FC<HistoryCardProps> = ({ item, active, onClick }) => {
  
  return (
    <CardWrapper active={active} onClick={onClick}>
      <CardHeader>
        <CardDateRange>{`${moment(item.startTime, 'MM-DD-YYYY hh:mm A').format('MM/DD/YYYY hh:mm A')} - ${moment(item.endTime, 'MM-DD-YYYY hh:mm A').format('hh:mm A')}`}</CardDateRange>
      </CardHeader>

    <CardReasonLine>
      Reason: <CardReasonValue>{item.reason}</CardReasonValue>
    </CardReasonLine>
  </CardWrapper>
);};

export default HistoryCard;

const CardWrapper = styled.div<{ active?: boolean }>`
  background: ${({ active }) => (active ? '#e6f4ff' : '#fff')};
  border-radius: 10px;
  border: 1px solid ${({ active }) => (active ? '#1677ff' : '#e8e8e8')};
  padding: 10px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: all 0.15s ease;
  &:hover {
    background: ${({ active }) => (active ? '#d0e9ff' : '#f5f5f5')};
  }
`;

const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
`;

const CardDateRange = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 2px;
`;

const CardReasonLine = styled.div`
  font-size: 11px;
  color: #888;
`;

const CardReasonValue = styled.span`
  color: #e05a5a;
  font-weight: 600;
`;
